import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

new Swiper('.component-numbers .swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 8,
  spaceBetween: 12,
  speed: 5000,
  loop: true,
  navigation: {
    enabled: false,
  },
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  breakpoints: {
    300: {
      slidesPerView: 3,
      spaceBetween: 12,
      centeredSlides: true,
    },
    390: {
      slidesPerView: 3,
      centeredSlides: true,
    },
    576: {
      slidesPerView: 6,
    },
    1024: {
      slidesPerView: 7,
    },
    1600: {
      slidesPerView: 8,
    },
    1800: {
      slidesPerView: 9,
    },
    2200: {
      slidesPerView: 13,
    }
  }
});
